import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=4a0bc45a&scoped=true"
import script from "./ActivityItem.vue?vue&type=script&lang=js"
export * from "./ActivityItem.vue?vue&type=script&lang=js"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=4a0bc45a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0bc45a",
  null
  
)

export default component.exports